var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-container"},[_c('el-timeline',_vm._l((_vm.timeLine),function(item){return _c('el-timeline-item',{key:item.id,attrs:{"timestamp":item.modified_time,"placement":"top"}},[_c('span',[_vm._v(_vm._s(`（${_vm.data.name}）-完成-${item.title}`))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }